
import { OpenBookingSports } from "@/constants/playground.enums";
import { matchTypesOptions } from "@/constants/radio-options.constants";
import { BookingDetailsDto } from "@/generated-sources/prenotazioni-api";
import { computed, defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import NormalPlayerItem from "./normal-player-item/NormalPlayerItem.vue";

export default defineComponent({
  name: "NormalMatchPlayers",
  components: {
    NormalPlayerItem,
  },
  props: {
    match: {
      type: Object,
      default: null,
    },
    players: {
       type: Array,
       default: new Array([]),
    },
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    const { t, locale } = useI18n();
    const match = props.match as BookingDetailsDto;

    /* COMPUTED */
    const clubId = match.club_id;

    const playersList = computed(function() {
      // INIT
      const arr = [];

      if (!match) return arr;

      const sport = match.playground_sport;
      const size = match.playground_size;

      let value: OpenBookingSports = null;

      switch (sport) {
        case "PADEL":
          value =
            size === "DOUBLE"
              ? OpenBookingSports.PADEL
              : OpenBookingSports.PADEL_SINGOLO;
          break;
        case "TENNIS":
          value =
            size === "DOUBLE"
              ? OpenBookingSports.TENNIS_DOUBLE
              : OpenBookingSports.TENNIS;
          break;
      }

      const matchType = matchTypesOptions.find((el) => el.value === value);
      const num = matchType.participants;

      // ITERATE
      for (let i = 0; i < num; i++) {
        const item = match[`player_${i + 1}`];
        if (item) {
          if (i === 0) {
            item.id = match[`wesmash_user_id`];
          } else {
            item.id = match[`wesmash_user${i + 1}_id`];
          }
        }
        arr.push(item);
      }

      // RETURN
      return arr;
    });

    // SYSTEM
    onMounted(() => {
      // getMatch();
    });

    // FUNCTIONS
    // function getMatch() {
    //   store
    //     .dispatch(ActionTypes.GET_BOOKING_DETAIL, { id: matchId.toString() })
    //     .then((response) => {
    //       match.value = response;

    //       match.value.description = match.value.description || "";
    //     });
    // }
    function refresh() {
      emit("refresh");
    }

    return {
      t,
      locale,

      // DATA
      playersList,
      clubId,

      // METHODS
      refresh,
    };
  },
});
